import { css } from '@emotion/core';
import { Icon } from '@veeva/corgix/icon';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import PropTypes from 'prop-types';
import { useTheme } from 'emotion-theming';
import ResponsiveTooltip from './ResponsiveTooltip';

const propTypes = {
    ariaLabel: PropTypes.string,
    helpIconCSS: PropTypes.shape({}),
    message: PropTypes.node,
};

const HelpIcon = ({ ariaLabel, helpIconCSS, message }) => {
    const { lightGray, black } = useTheme();

    const iconButtonCSS = () => {
        return [
            css`
                width: 1.5rem;
                height: 1.5rem;
                border: none;
                padding: 0;
                vertical-align: middle;
                display: inline-block;

                > svg:first-of-type {
                    color: ${lightGray};
                    width: 1.3333rem;
                    height: 1.3333rem;

                    &:hover,
                    &:focus {
                        outline: none;
                        cursor: pointer;
                        color: ${black};
                    }
                }
            `,
            helpIconCSS,
        ];
    };

    const tooltipCSS = css`
        > div > div {
            max-width: 20.833rem;
        }
    `;

    return (
        <ResponsiveTooltip content={message} desktopTooltipCSS={tooltipCSS}>
            <div css={iconButtonCSS}>
                <Icon aria-label={ariaLabel} type={faQuestionCircle} />
            </div>
        </ResponsiveTooltip>
    );
};

HelpIcon.propTypes = propTypes;

export default HelpIcon;
